import DrawingCanvas from 'src/components/organisms/DrawingCanvas/DrawingCanvas'

export default DrawingCanvas
